var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('opq-basic-appbar',[_vm._v("Ordre des psychologues du Québec - Création de compte portail")]),_c('v-main',[_c('v-card',{staticClass:"pa-4 pa-md-12 my-md-12 my-0 mx-auto",attrs:{"max-width":"960"}},[_c('creation-de-compte',{staticClass:"mx-3 mx-md-auto"})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }